export default {
    SEND_SECURE_MESSAGE_BEGIN: 'SEND_SECURE_MESSAGE_BEGIN',
    SEND_SECURE_MESSAGE_SUCCESS: 'SEND_SECURE_MESSAGE_SUCCESS',
    SEND_SECURE_MESSAGE_ERROR: 'SEND_SECURE_MESSAGE_ERROR',
    SEND_SECURE_MESSAGE_CLEANUP: 'SEND_SECURE_MESSAGE_CLEANUP'
};